import { all, put, takeEvery } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import firebase from "firebase/app";
import "firebase/auth";
import {
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAILURE,
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  CHNAGE_LANGUAGE,
  FETCH_ALL_CLUBS_REQUEST
} from "../constants";
import { firebaseLogin, firebaseEmailRegister } from "../api/api";

function* loginUserFn({ payload }: any): any {
  const { user, emailVerified, authType } = payload;
  try {
    const response = yield firebaseLogin(user);
    if (response) {
      yield put({
        type: LOGIN_USER_SUCCESS,
        payload: {
          user: response,
          emailVerified,
          authType,
        },
      });
      yield put({
        type: FETCH_ALL_CLUBS_REQUEST,
        payload: {
          currentUser: response
        }
      })
      // if(response.role === "regular") history.push("/booking");
      // else history.push("/dashboard");
    } else {
      yield put({ type: LOGIN_USER_FAILURE });
    }
  } catch (err) {
    yield put({ type: LOGIN_USER_FAILURE });
  }
}

function* registerUserFn({ payload }: any): any {
  const { fullName, email, password, gender, phoneNumber, user } = payload;
  try {
    const response = yield firebaseEmailRegister(
      fullName,
      email,
      password,
      gender,
      phoneNumber,
      user
    );
    if (response) {
      yield put({ type: REGISTER_USER_SUCCESS, payload: { user: response } });
    } else {
      yield put({ type: REGISTER_USER_FAILURE });
    }
  } catch (err) {
    yield put({ type: REGISTER_USER_FAILURE });
  }
}

function setLanguage({ payload }: any): any {
  firebase.auth().languageCode = payload;
}

export default function* authSaga(): SagaIterator {
  yield all([
    takeEvery(LOGIN_USER_REQUEST, loginUserFn),
    takeEvery(REGISTER_USER_REQUEST, registerUserFn),
    takeEvery(CHNAGE_LANGUAGE, setLanguage),
  ]);
}
